export const appSettingsTestUserLogsSearchTerms = "/app_settings/test_user_logs/search_terms";
